'use strict';

angular.module('searchControllers', [
    'services.userAccessRequest',
    'services.search',
    'mgcrea.ngStrap'
]);